import { render, staticRenderFns } from "./WysiwygEditor.vue?vue&type=template&id=4286f9d3&scoped=true&"
import script from "./WysiwygEditor.vue?vue&type=script&lang=ts&"
export * from "./WysiwygEditor.vue?vue&type=script&lang=ts&"
import style0 from "./WysiwygEditor.vue?vue&type=style&index=0&id=4286f9d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4286f9d3",
  null
  
)

export default component.exports